export var EACState;
(function (EACState) {
    EACState[EACState["Unknown"] = 0] = "Unknown";
    EACState[EACState["Disconnected"] = 1] = "Disconnected";
    EACState[EACState["Connected"] = 2] = "Connected";
    EACState[EACState["ConnectedSlow"] = 3] = "ConnectedSlow";
})(EACState || (EACState = {}));
export var EBatteryState;
(function (EBatteryState) {
    EBatteryState[EBatteryState["Unknown"] = 0] = "Unknown";
    EBatteryState[EBatteryState["Discharging"] = 1] = "Discharging";
    EBatteryState[EBatteryState["Charging"] = 2] = "Charging";
    EBatteryState[EBatteryState["Full"] = 3] = "Full";
})(EBatteryState || (EBatteryState = {}));
export var EStorageFormatStage;
(function (EStorageFormatStage) {
    EStorageFormatStage[EStorageFormatStage["Invalid"] = 0] = "Invalid";
    EStorageFormatStage[EStorageFormatStage["NotRunning"] = 1] = "NotRunning";
    EStorageFormatStage[EStorageFormatStage["Starting"] = 2] = "Starting";
    EStorageFormatStage[EStorageFormatStage["Testing"] = 3] = "Testing";
    EStorageFormatStage[EStorageFormatStage["Rescuing"] = 4] = "Rescuing";
    EStorageFormatStage[EStorageFormatStage["Formatting"] = 5] = "Formatting";
    EStorageFormatStage[EStorageFormatStage["Finalizing"] = 6] = "Finalizing";
})(EStorageFormatStage || (EStorageFormatStage = {}));
export var EOSType;
(function (EOSType) {
    EOSType[EOSType["Web"] = -700] = "Web";
    EOSType[EOSType["Ios"] = -600] = "Ios";
    EOSType[EOSType["Android"] = -500] = "Android";
    EOSType[EOSType["Android6"] = -499] = "Android6";
    EOSType[EOSType["Android7"] = -498] = "Android7";
    EOSType[EOSType["Android8"] = -497] = "Android8";
    EOSType[EOSType["Android9"] = -496] = "Android9";
    EOSType[EOSType["Ps3os"] = -300] = "Ps3os";
    EOSType[EOSType["Linux"] = -203] = "Linux";
    EOSType[EOSType["Linux22"] = -202] = "Linux22";
    EOSType[EOSType["Linux24"] = -201] = "Linux24";
    EOSType[EOSType["Linux26"] = -200] = "Linux26";
    EOSType[EOSType["Linux32"] = -199] = "Linux32";
    EOSType[EOSType["Linux35"] = -198] = "Linux35";
    EOSType[EOSType["Linux36"] = -197] = "Linux36";
    EOSType[EOSType["Linux310"] = -196] = "Linux310";
    EOSType[EOSType["Linux316"] = -195] = "Linux316";
    EOSType[EOSType["Linux318"] = -194] = "Linux318";
    EOSType[EOSType["Linux3x"] = -193] = "Linux3x";
    EOSType[EOSType["Linux4x"] = -192] = "Linux4x";
    EOSType[EOSType["Linux41"] = -191] = "Linux41";
    EOSType[EOSType["Linux44"] = -190] = "Linux44";
    EOSType[EOSType["Linux49"] = -189] = "Linux49";
    EOSType[EOSType["Linux414"] = -188] = "Linux414";
    EOSType[EOSType["Linux419"] = -187] = "Linux419";
    EOSType[EOSType["Linux5x"] = -186] = "Linux5x";
    EOSType[EOSType["Linux54"] = -185] = "Linux54";
    EOSType[EOSType["Linux6x"] = -184] = "Linux6x";
    EOSType[EOSType["Linux7x"] = -183] = "Linux7x";
    EOSType[EOSType["Linux510"] = -182] = "Linux510";
    EOSType[EOSType["Macos"] = -102] = "Macos";
    EOSType[EOSType["Macos104"] = -101] = "Macos104";
    EOSType[EOSType["Macos105"] = -100] = "Macos105";
    EOSType[EOSType["Macos1058"] = -99] = "Macos1058";
    EOSType[EOSType["Macos106_unused1"] = -98] = "Macos106_unused1";
    EOSType[EOSType["Macos106_unused2"] = -97] = "Macos106_unused2";
    EOSType[EOSType["Macos106_unused3"] = -96] = "Macos106_unused3";
    EOSType[EOSType["Macos106"] = -95] = "Macos106";
    EOSType[EOSType["Macos1063"] = -94] = "Macos1063";
    EOSType[EOSType["Macos1064_slgu"] = -93] = "Macos1064_slgu";
    EOSType[EOSType["Macos1067"] = -92] = "Macos1067";
    EOSType[EOSType["Macos1067_unused"] = -91] = "Macos1067_unused";
    EOSType[EOSType["Macos107"] = -90] = "Macos107";
    EOSType[EOSType["Macos108"] = -89] = "Macos108";
    EOSType[EOSType["Macos109"] = -88] = "Macos109";
    EOSType[EOSType["Macos1010"] = -87] = "Macos1010";
    EOSType[EOSType["Macos1011"] = -86] = "Macos1011";
    EOSType[EOSType["Macos1012"] = -85] = "Macos1012";
    EOSType[EOSType["Macos1013"] = -84] = "Macos1013";
    EOSType[EOSType["Macos1014"] = -83] = "Macos1014";
    EOSType[EOSType["Macos1015"] = -82] = "Macos1015";
    EOSType[EOSType["Macos1016"] = -81] = "Macos1016";
    EOSType[EOSType["Macos11"] = -80] = "Macos11";
    EOSType[EOSType["Macos111"] = -79] = "Macos111";
    EOSType[EOSType["Macos1017"] = -78] = "Macos1017";
    EOSType[EOSType["Macos12"] = -77] = "Macos12";
    EOSType[EOSType["Macos1018"] = -76] = "Macos1018";
    EOSType[EOSType["Macos13"] = -75] = "Macos13";
    EOSType[EOSType["Macos1019"] = -74] = "Macos1019";
    EOSType[EOSType["Macos14"] = -73] = "Macos14";
    EOSType[EOSType["Macos1020"] = -72] = "Macos1020";
    EOSType[EOSType["Macos15"] = -71] = "Macos15";
    EOSType[EOSType["Unknown"] = -1] = "Unknown";
    EOSType[EOSType["Windows"] = 0] = "Windows";
    EOSType[EOSType["Win311"] = 1] = "Win311";
    EOSType[EOSType["Win95"] = 2] = "Win95";
    EOSType[EOSType["Win98"] = 3] = "Win98";
    EOSType[EOSType["WinME"] = 4] = "WinME";
    EOSType[EOSType["WinNT"] = 5] = "WinNT";
    EOSType[EOSType["Win200"] = 6] = "Win200";
    EOSType[EOSType["WinXP"] = 7] = "WinXP";
    EOSType[EOSType["Win2003"] = 8] = "Win2003";
    EOSType[EOSType["WinVista"] = 9] = "WinVista";
    EOSType[EOSType["Win7"] = 10] = "Win7";
    EOSType[EOSType["Win2008"] = 11] = "Win2008";
    EOSType[EOSType["Win2012"] = 12] = "Win2012";
    EOSType[EOSType["Win8"] = 13] = "Win8";
    EOSType[EOSType["Win81"] = 14] = "Win81";
    EOSType[EOSType["Win2012R2"] = 15] = "Win2012R2";
    EOSType[EOSType["Win10"] = 16] = "Win10";
    EOSType[EOSType["Win2016"] = 17] = "Win2016";
    EOSType[EOSType["Win2019"] = 18] = "Win2019";
    EOSType[EOSType["Win2022"] = 19] = "Win2022";
    EOSType[EOSType["Win11"] = 20] = "Win11";
})(EOSType || (EOSType = {}));
